// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 331) return "static/css/331.6323396c3.chunk.css";
	// return url for filenames based on template
	return undefined;
};